import { LogApi } from "../../businessLogic/api/logApi";
import { StatsApi } from "../../businessLogic/api/statsApi";

export const StatsData = () => {
    const statsApi = StatsApi();
    const logApi = LogApi();

    const getRealStatsData = async () => {
        try {
            const ppeData = await statsApi.GetPPEByAzienda();
            const rischioSpecificoData = await statsApi.GetEfAdeguataLivelloByAzienda();
            const zonaGeograficaData = await statsApi.GetZonaGeograficaByAzienda();
            const valutazioniData = await statsApi.GetValutazioniByAzienda();
            const prestazioniAreaGeografica = await statsApi.GetPrestazioniZonaGeografica();
            const livelliA = await statsApi.GetALivelliByAzienda();
            const livelliB = await statsApi.GetBLivelliByAzienda();
            const livelliC = await statsApi.GetCLivelliByAzienda();
            const prestRischioInerente = await statsApi.GetPrestazioniRischioInerente();
            const prestRischioSpecificoComplessivo = await statsApi.GetPrestazioniRischioComplessivo();         
            const prestRischioSpecifico = await statsApi.GetPrestazioniRischioSpecifico();
            const prestRischioEffetivo = await statsApi.GetPrestazioniRischioEffettivo();
            return {
                ppe: ppeData,
                zoneGeografiche: zonaGeograficaData,
                rischioSpecifico: rischioSpecificoData,
                valutazioni:valutazioniData,
                prestazioniAreaGeografica : prestazioniAreaGeografica,
                naturaGiuridicaPunteggio: livelliA?.naturaGiuridicaPunteggio ?? null,
                attivitaSvoltaPunteggio: livelliA?.attivitaSvoltaPunteggio ?? null,
                comportamentoPunteggio: livelliA?.comportamentoPunteggio ?? null,
                areaGeograficaPunteggio: livelliA?.areaGeograficaPunteggio ?? null,                
                b1Punteggio: livelliB?.b1Punteggio ?? null,
                b2Punteggio: livelliB?.b2Punteggio ?? null,
                b3Punteggio: livelliB?.b3Punteggio ?? null,
                b4Punteggio: livelliB?.b4Punteggio ?? null,
                b5Punteggio: livelliB?.b5Punteggio ?? null,
                b6Punteggio: livelliB?.b6Punteggio ?? null,
                c1Punteggio: livelliC?.c1Punteggio ?? null,
                c2Punteggio: livelliC?.c2Punteggio ?? null,
                c3Punteggio: livelliC?.c3Punteggio ?? null,
                rischioInerente: prestRischioInerente ?? null,
                rischioSpecificoPrestazione: prestRischioSpecifico ?? null,
                rischioSpecificoComplessivo: prestRischioSpecificoComplessivo ?? null,
                rischioEffettivo: prestRischioEffetivo ?? null
            }
        } catch (error) {
            console.error('Errore nel recupero dei dati statistici:', error);  
            logApi.AddLog(error.message,error.stack,"getRealStatsData","statsExampleData")
        }
    };

    return {
        getRealStatsData,
    };
}